import { useFetchPrice, useGetBookingSession } from '@massilia/queries'
import { createFileRoute } from '@tanstack/react-router'

import { bookingSessionSearchSchema } from '@/lib/schemas/booking-session-search.schema'
import { InformationsPage } from '@/routes/informations/-components/informations-page'

export const Route = createFileRoute('/_booking/informations')({
  component: InformationsRoute,
  validateSearch: bookingSessionSearchSchema,
})

function InformationsRoute() {
  const { session: sessionId } = Route.useSearch()

  const { data: session, isLoading } = useGetBookingSession(sessionId, {
    throwOnError: true,
  })

  // Eagerly fetch Affidium price data on page load (for sidebar luggage/price display).
  // throwOnError: a price failure must surface via the _booking BookingError boundary
  // instead of leaving the sidebar skeleton spinning indefinitely.
  useFetchPrice(sessionId, { throwOnError: true })
  return <InformationsPage isLoading={isLoading} session={session} sessionId={sessionId} />
}
